import * as React from "react";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import MessagesTable from "../components/Tables/MessagesTable";
import PageTitles from "../components/Layout/PageTitles";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

export default function Messages() {


  
      //alert states:
      const [errOpen, setErrOpen] = React.useState(false);
      const [errMessage, setErrMessage] = React.useState("");
  
  
    //error alert
  
    const Alert = React.forwardRef(function Alert(props, ref) {
      return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });
  
    const handleAlertClose = (event, reason) => {
      if (reason === "clickaway") {
        return;
      }
  
      setErrOpen(false);
    };


  return (
    <>
      <PageTitles title={"Messages"} />
      <Grid id="i" container spacing={3} direction="row">
        <Grid item id="j" xs>
          <Grid item id="k" sx={{ mb: 3 }}>
            <Paper
              id="l"
              sx={{
                p: 2,
                display: "flex",
                flexDirection: "column",
                height: "auto",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
               <Snackbar
                  open={errOpen}
                  autoHideDuration={6000}
                  onClose={handleAlertClose}
                >
                  {
                    <Alert
                      onClose={handleAlertClose}
                      severity={"error"}
                      sx={{ width: "100%" }}
                    >
                      {errMessage}
                    </Alert>
                  }
                </Snackbar>
              <MessagesTable setErrOpen={setErrOpen} setErrMessage={setErrMessage} />
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
